"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImaAdsManager = void 0;
var player_base_1 = require("@24i/player-base");
var player_plugin_ads_1 = require("@24i/player-plugin-ads");
var player_utils_1 = require("@24i/player-utils");
var ima_1 = require("@alugha/ima");
var ImaAdsManager = (function (_super) {
    __extends(ImaAdsManager, _super);
    function ImaAdsManager(videoElement, adContainer, player) {
        var _this = _super.call(this) || this;
        _this.timelineEvents = [];
        _this.currentAdBreak = null;
        _this.currentAd = null;
        _this.adBreaks = [];
        _this.paused = false;
        _this.playedOffsets = [];
        _this.adVolume = 1;
        _this.adMuted = false;
        _this.mainContentDuration = 0;
        _this.onPlayerMetadataLoaded = function () {
            if (_this.player.currentAdBreak)
                return;
            _this.mainContentDuration = _this.player.duration;
        };
        _this.onPlayerEnded = function () {
            _this.adsLoader.contentComplete();
        };
        _this.onPlayerResize = function () {
            if (_this.adsManager) {
                var _a = _this.videoElement, clientWidth = _a.clientWidth, clientHeight = _a.clientHeight;
                _this.adsManager.resize(clientWidth, clientHeight, _this.ima.ViewMode.NORMAL);
            }
        };
        _this.onAdsManagerLoaded = function (adsManagerLoadedEvent) {
            _this.adsManager = adsManagerLoadedEvent.getAdsManager(_this.videoElement);
            _this.updateTimeline();
            _this.addAdsManagerListeners();
            _this.adDisplayContainer.initialize();
            var _a = _this.videoElement, clientWidth = _a.clientWidth, clientHeight = _a.clientHeight;
            _this.adsManager.init(clientWidth, clientHeight, _this.ima.ViewMode.NORMAL);
            if (_this.timelineEvents.length === 0) {
                _this.adsManager.start();
            }
        };
        _this.onAdError = function (event) {
            if (_this.adsManager) {
                _this.adsManager.destroy();
                _this.adsManager = null;
            }
            _this.player.events.triggerEvent('aderror', {
                error: event.getError().getMessage(),
            });
        };
        _this.onAdBreakStarted = function (event) {
            _this.adVolume = _this.player.volume;
            _this.adMuted = _this.player.muted;
            _this.adsManager.setVolume(!_this.adMuted ? _this.adVolume : 0);
            var adPodInfo = event.getAd().getAdPodInfo();
            var adBreakOffset = _this.getAdjustedTimeOffset(adPodInfo.getTimeOffset());
            var adBreakIndex = adPodInfo.getPodIndex();
            var totalAds = adPodInfo.getTotalAds();
            _this.currentAdBreak = {
                adBreakOffset: adBreakOffset,
                adBreakIndex: adBreakIndex,
                totalAds: totalAds,
            };
            _this.videoElement.pause();
            _this.player.events.triggerEvent('adbreakstarted', {
                adBreakOffset: adBreakOffset,
                adBreakIndex: adBreakIndex,
                totalAds: totalAds,
            });
        };
        _this.onAdStarted = function (event) {
            var _a;
            var adInfo = event.getAd();
            var adPodInfo = adInfo.getAdPodInfo();
            var adBreakIndex = adPodInfo.getPodIndex();
            var adPosition = adPodInfo.getAdPosition();
            var title = adInfo.getTitle();
            var description = adInfo.getDescription();
            var duration = player_utils_1.secondsToMilliseconds(adInfo.getDuration());
            var skipOffset = adInfo.getSkipTimeOffset() < 0
                ? null
                : player_utils_1.secondsToMilliseconds(adInfo.getSkipTimeOffset());
            var adKey = Object.keys(adInfo)[0];
            var clickLink = (_a = adInfo[adKey]) === null || _a === void 0 ? void 0 : _a.clickThroughUrl;
            _this.currentAd = {
                adBreakIndex: adBreakIndex,
                adPosition: adPosition,
                title: title,
                description: description,
                duration: duration,
                skipOffset: skipOffset,
                clickLink: clickLink,
                inStreamAdvertisement: false,
            };
            _this.player.events.triggerEvent('adstarted', {
                adBreakIndex: adBreakIndex,
                adPosition: adPosition,
                title: title,
                description: description,
                duration: duration,
                skipOffset: skipOffset,
                clickLink: clickLink,
                inStreamAdvertisement: false,
            });
            _this.player.events.triggerEvent('playing');
            _this.player.events.triggerEvent('durationchange', {
                duration: duration,
            });
        };
        _this.onAdPaused = function () {
            _this.paused = true;
            _this.player.events.triggerEvent('pause');
        };
        _this.onAdResumed = function () {
            _this.paused = false;
            _this.player.events.triggerEvent('play');
            _this.player.events.triggerEvent('playing');
        };
        _this.onAdProgress = function () {
            _this.paused = false;
            _this.player.events.triggerEvent('timeupdate', {
                currentTime: _this.currentTime,
            });
        };
        _this.onAdBreakEnded = function () {
            if (!_this.player.ended) {
                _this.videoElement.play();
            }
            if (_this.currentAdBreak) {
                _this.playedOffsets.push(_this.currentAdBreak.adBreakOffset);
            }
            _this.currentAdBreak = null;
            _this.currentAd = null;
            _this.player.events.triggerEvent('adbreakended');
            _this.player.events.triggerEvent('durationchange', {
                duration: _this.player.duration,
            });
            _this.updateTimeline();
        };
        _this.onAdBreakReady = function (event) {
            var _a;
            var adBreakTime = event.getAdData().adBreakTime;
            var startPosition = (_a = _this.player.startPosition) !== null && _a !== void 0 ? _a : 0;
            var adjustedTime = _this.getAdjustedTimeOffset(adBreakTime);
            if (adBreakTime === 0 ||
                adBreakTime === -1 ||
                adjustedTime > startPosition) {
                _this.adsManager.start();
            }
        };
        _this.videoElement = videoElement;
        _this.adContainer = adContainer;
        _this.player = player;
        return _this;
    }
    ImaAdsManager.prototype.canLoad = function (source) {
        return Boolean(source.ads);
    };
    ImaAdsManager.prototype.load = function (source) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, adsRequest;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, ima_1.loadImaSdk()];
                    case 1:
                        _a.ima = _b.sent();
                        this.adDisplayContainer = new this.ima.AdDisplayContainer(this.adContainer, this.videoElement);
                        this.adsLoader = new this.ima.AdsLoader(this.adDisplayContainer);
                        this.adsLoader.getSettings().setAutoPlayAdBreaks(false);
                        this.addAdsLoaderListeners();
                        adsRequest = new this.ima.AdsRequest();
                        adsRequest.adTagUrl = source.ads;
                        this.adsLoader.requestAds(adsRequest);
                        return [2, source];
                }
            });
        });
    };
    ImaAdsManager.prototype.unload = function () {
        var _a, _b, _c;
        (_a = this.adsManager) === null || _a === void 0 ? void 0 : _a.destroy();
        (_b = this.adsLoader) === null || _b === void 0 ? void 0 : _b.destroy();
        (_c = this.adDisplayContainer) === null || _c === void 0 ? void 0 : _c.destroy();
        this.adsManager = null;
        this.adsLoader = null;
        this.adDisplayContainer = null;
        this.removeAdsLoaderListeners();
    };
    ImaAdsManager.prototype.addAdsLoaderListeners = function () {
        this.videoElement.addEventListener('ended', this.onPlayerEnded);
        this.player.addEventListener('loadedmetadata', this.onPlayerMetadataLoaded);
        this.player.addEventListener('durationchange', this.onPlayerMetadataLoaded);
        window.addEventListener('resize', this.onPlayerResize);
        this.adsLoader.addEventListener(this.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, this.onAdsManagerLoaded);
        this.adsLoader.addEventListener(this.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError);
    };
    ImaAdsManager.prototype.removeAdsLoaderListeners = function () {
        this.videoElement.removeEventListener('ended', this.onPlayerEnded);
        window.removeEventListener('resize', this.onPlayerResize);
    };
    ImaAdsManager.prototype.seek = function () {
        return {};
    };
    ImaAdsManager.prototype.setMetadata = function () {
    };
    ImaAdsManager.prototype.getMediaTime = function (contentTime) {
        return contentTime;
    };
    ImaAdsManager.prototype.getContentTime = function (mediaTime) {
        return mediaTime;
    };
    Object.defineProperty(ImaAdsManager.prototype, "volume", {
        get: function () {
            return this.adVolume;
        },
        set: function (volume) {
            var _a;
            this.adVolume = volume;
            (_a = this.adsManager) === null || _a === void 0 ? void 0 : _a.setVolume(!this.adMuted ? volume : 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImaAdsManager.prototype, "muted", {
        get: function () {
            return this.adMuted;
        },
        set: function (muted) {
            var _a;
            this.adMuted = muted;
            (_a = this.adsManager) === null || _a === void 0 ? void 0 : _a.setVolume(!muted ? this.adVolume : 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImaAdsManager.prototype, "isPlayingClientSide", {
        get: function () {
            return Boolean(this.currentAdBreak);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImaAdsManager.prototype, "currentTime", {
        get: function () {
            if (!this.currentAd)
                return 0;
            return (this.currentAd.duration -
                player_utils_1.secondsToMilliseconds(this.adsManager.getRemainingTime()));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImaAdsManager.prototype, "duration", {
        get: function () {
            if (!this.currentAd)
                return 0;
            return this.currentAd.duration;
        },
        enumerable: false,
        configurable: true
    });
    ImaAdsManager.prototype.play = function () {
        var _a;
        this.paused = false;
        (_a = this.adsManager) === null || _a === void 0 ? void 0 : _a.resume();
    };
    ImaAdsManager.prototype.pause = function () {
        var _a;
        this.paused = true;
        (_a = this.adsManager) === null || _a === void 0 ? void 0 : _a.pause();
    };
    Object.defineProperty(ImaAdsManager.prototype, "canSkipAd", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.adsManager) === null || _a === void 0 ? void 0 : _a.getAdSkippableState()) !== null && _b !== void 0 ? _b : false;
        },
        enumerable: false,
        configurable: true
    });
    ImaAdsManager.prototype.skipAd = function () {
        if (!this.adsManager)
            return;
        this.adsManager.skip();
    };
    ImaAdsManager.prototype.shouldPostponeInitialSeek = function () {
        return false;
    };
    ImaAdsManager.prototype.getAdjustedTimeOffset = function (timeOffset) {
        return timeOffset < 0
            ? this.mainContentDuration
            : player_utils_1.secondsToMilliseconds(timeOffset);
    };
    ImaAdsManager.prototype.updateTimeline = function () {
        var _this = this;
        this.timelineEvents = this.adsManager
            .getCuePoints()
            .map(function (timeOffset) {
            var adjustedOffset = _this.getAdjustedTimeOffset(timeOffset);
            var played = _this.playedOffsets.includes(adjustedOffset)
                ? player_base_1.ITimelineEventPlayed.PLAYED
                : player_base_1.ITimelineEventPlayed.UNPLAYED;
            return {
                start: adjustedOffset,
                end: adjustedOffset,
                played: played,
                type: player_base_1.ISourceTimelineEventType.ADVERTISEMENT,
            };
        });
        this.adBreaks = this.timelineEvents.map(function (event) { return event.start; });
    };
    ImaAdsManager.prototype.addAdsManagerListeners = function () {
        this.adsManager.addEventListener(this.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, this.onAdBreakStarted);
        this.adsManager.addEventListener(this.ima.AdEvent.Type.STARTED, this.onAdStarted);
        this.adsManager.addEventListener(this.ima.AdEvent.Type.PAUSED, this.onAdPaused);
        this.adsManager.addEventListener(this.ima.AdEvent.Type.RESUMED, this.onAdResumed);
        this.adsManager.addEventListener(this.ima.AdEvent.Type.AD_PROGRESS, this.onAdProgress);
        this.adsManager.addEventListener(this.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError);
        this.adsManager.addEventListener(this.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, this.onAdBreakEnded);
        this.adsManager.addEventListener(this.ima.AdEvent.Type.AD_BREAK_READY, this.onAdBreakReady);
    };
    return ImaAdsManager;
}(player_plugin_ads_1.AdsManager));
exports.ImaAdsManager = ImaAdsManager;
//# sourceMappingURL=index.js.map